export const environment = {
    // ROOT_URL: 'https://ep-fr-preprod.public.tiko.energy',
    ROOT_URL: 'https://ep-fr.tiko.ch',
    CUSTOMER_PORTAL_URL: 'https://particuliers-tiko.fr',
    APP_NAME: 'tiko',
    DEFAULT_LOCALE: 'fr',
    LOGIN_DEV_USERNAME: '',
    LOGIN_DEV_PASSWORD: '',
    SKIP_LTE_CHECK: false,
};
